define("settings/components/downgrade/linkinbio-pages", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--card u--m__b" data-test-id="linkinbio-pages">
    <table class="o--table o--table--condensed o--table--sort o--table--hover u--m__b__0">
      <tbody>
        <div class="tDG--tableScroll tDG--tableScroll--lg u--p__0">
          {{#each @linkinbioPages as |linkinbioPage|}}
            <Downgrade::LinkinbioPage @deleteLinkinbioPage={{@deleteLinkinbioPage}} @linkinbioPage={{linkinbioPage}} />
          {{/each}}
        </div>
      </tbody>
    </table>
  </div>
  */
  {
    "id": "fg4CfvCL",
    "block": "[[[10,0],[14,0,\"o--card u--m__b\"],[14,\"data-test-id\",\"linkinbio-pages\"],[12],[1,\"\\n  \"],[10,\"table\"],[14,0,\"o--table o--table--condensed o--table--sort o--table--hover u--m__b__0\"],[12],[1,\"\\n    \"],[10,\"tbody\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tDG--tableScroll tDG--tableScroll--lg u--p__0\"],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,1]],null]],null],null,[[[1,\"          \"],[8,[39,2],null,[[\"@deleteLinkinbioPage\",\"@linkinbioPage\"],[[30,3],[30,2]]],null],[1,\"\\n\"]],[2]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@linkinbioPages\",\"linkinbioPage\",\"@deleteLinkinbioPage\"],false,[\"each\",\"-track-array\",\"downgrade/linkinbio-page\"]]",
    "moduleName": "settings/components/downgrade/linkinbio-pages.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});